import React from "react";
import { useTranslation } from 'react-i18next';
const Footer = (props) => {
  const { t } = useTranslation();
  const { storeInfo} = props;
  return (
    <footer className="py-3" style={{ backgroundColor: storeInfo.foooterColor ?? '#333' }}>
      <div className="container">
        <div className="row g-3">
          <div className="col-md-12">
            <p className="text-center mb-0">
              <span className="text-decoration-none" style={{ color: '#FFFFFF' }}>
                &copy; {t("FOOTER.COPYRIGHT")} {(new Date().getFullYear())}. {storeInfo.storeDetails.organizationName}
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
